
import objectPath from 'object-path'

const getters = {
  getTransfers: state => state.transfers,
  getTransfer: state => transferIndex => state.transfers[transferIndex].transfers,
  getTransferForm: state => transferIndex => state.transfers[transferIndex].form,
  // eslint-disable-next-line
  getTransferFormForSearch: (state, getters) => transferIndex => {
    const {
      time,
      returnTime,
      checkInDate,
      checkOutDate,
      cityFrom,
      cityTo,
      placeFrom,
      placeTo,
      isRepeatedSearch
    } = getters.getTransferForm(transferIndex)

    const pickUpLocation = placeFrom.current
    const [pickUpLocationRouteId, pickUpLocationCode] = pickUpLocation ? pickUpLocation.split('_') : ['', '']
    const dropOff = placeTo.current
    const [dropOffRouteId, dropOffCode] = dropOff ? dropOff.split('_') : ['', '']

    const {
      adults,
      numbrOfChildren: children,
      numberOfInfants: infants
    } = getters.getNumberOfTourists

    const currency = getters.getCartPrice.currency

    return {
      pickUpCityId: cityFrom.slug,
      pickUpCode: pickUpLocationCode,
      pickUpRouteId: pickUpLocationRouteId,
      dropOffCityId: cityTo.slug,
      dropOffCode,
      dropOffRouteId,
      adults,
      children,
      infants,
      date: checkInDate,
      returnDate: checkOutDate,
      time,
      returnTime,
      cityFrom,
      cityTo,
      isRepeatedSearch,
      currency
    }
  },
  getTransfersFlightIds: state => ({
    flightCode: state.transfer.form.flightCode,
    flightNumber: state.transfer.form.flightNumber,
    returnFlightCode: state.transfer.form.returnFlightCode,
    returnFlightNumber: state.transfer.form.returnFlightNumber
  }),
  getTransfersCurrent: state => target => objectPath.get(state, target).slug,
}

export default getters